module.exports = __webpack_public_path__ + "static/media/message-translate.29182a11.svg";